function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Artboard_2"
}, React.createElement("rect", {
  width: 36,
  height: 34
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard_2",
  "data-name": "Artboard \\u2013 2",
  clipPath: "url(#clip-Artboard_2)"
}, React.createElement("rect", {
  width: 36,
  height: 34,
  fill: "#fff"
}), React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(0 1)"
}, React.createElement("g", {
  id: "wallet_1",
  "data-name": "Rectangle 12",
  transform: "translate(0 7.667)",
  fill: "#fff",
  stroke: "#707070",
  strokeLinejoin: "round",
  strokeWidth: 2
}, React.createElement("rect", {
  width: 36,
  height: 25.333,
  stroke: "none"
}), React.createElement("rect", {
  x: 1,
  y: 1,
  width: 34,
  height: 23.333,
  fill: "none"
})), React.createElement("path", {
  id: "wallet_2",
  "data-name": "Path 16",
  d: "M33.333,311,43,302.333,48,307",
  transform: "translate(-28 -302.333)",
  fill: "none",
  stroke: "#707070",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "wallet_3",
  "data-name": "Path 17",
  d: "M40.667,311,53,304l2.75,4.583",
  transform: "translate(-24 -302.333)",
  fill: "none",
  stroke: "#707070",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var SvgWallets = function SvgWallets(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWallets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallets.77d189e4.svg";
export { ForwardRef as ReactComponent };